(function($, window, document) {
  $(function(){


    //-------------------------- 
    //Variable declaration
    //-------------------------- 
    var $window = $(window),
        $homepageSlideshow = $('.homepage-slideshow'),
        $productThumbandList = $('.products-wrapper-list, .products-wrapper, #frontpage-collections, #frontpage-collections-2, .owl-product-collection');


    //--------------------------     
    //Used to remove js/css files path
    //-------------------------- 
    var removejscssfile = function(filename, filetype){
     var targetelement=(filetype=="js")? "script" : (filetype=="css")? "link" : "none" //determine element type to create nodelist from
     var targetattr=(filetype=="js")? "src" : (filetype=="css")? "href" : "none" //determine corresponding attribute to test for
     var allsuspects=document.getElementsByTagName(targetelement)
     for (var i=allsuspects.length; i>=0; i--){ //search backwards within nodelist for matching elements to remove
      if (allsuspects[i] && allsuspects[i].getAttribute(targetattr)!=null && allsuspects[i].getAttribute(targetattr).indexOf(filename)!=-1)
       allsuspects[i].parentNode.removeChild(allsuspects[i]) //remove element by calling parentNode.removeChild()
     }
    }


    //-------------------------- 
    //Init wow animation
    //-------------------------- 
    
    new WOW({
        mobile: false
      }).init();
    


    //-------------------------- 
    //Init Number Incrementers
    //-------------------------- 
    var Incrementers = function() {
      $('.incrementer').each(function() {
        var $this = $(this);
        if(!$this.hasClass('generated')) {
          $this.find("input").hide();
          $this.append('<div class="dec button btn-default btn">-</div><span>'+ $this.find("input").val() +'</span><div class="inc button btn-default btn">+</div>');
          $this.addClass('generated');  
        }
      });

      $(".button").on("click", function() {

        var $button = $(this);
        var oldValue = $button.parent().find("input").val();

        if ($button.text() == "+") {
          var newVal = parseFloat(oldValue) + 1;
        } else {
         // Don't allow decrementing below zero
          if (oldValue > 1) {
            var newVal = parseFloat(oldValue) - 1;
          } else {
            newVal = 1;
          }
        }

        $button.parent().find("input").val(newVal);
        $button.parent().find("span").text(newVal);

      });
    };


    //-------------------------- 
    //Used to load product review widget
    //-------------------------- 
    var asyncLoad = function() {
      var urls = ["//productreviews.shopifyapps.com/assets/v4/spr.js"];
      for (var i = 0; i < urls.length; i++) {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = urls[i];
        var x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      }
    }


    //-------------------------- 
    //Used to animate slide show text
    //-------------------------- 
    var functionAnimateText = function(slider) {
      $(slider).find(".flex-active-slide .text, .flex-active-slide p, .flex-active-slide h1, .flex-active-slide .btn, hr").show();
      var $text = $(slider).find(".flex-active-slide p"),
          $headText = $(slider).find(".flex-active-slide h1"),
          $button = $(slider).find(".flex-active-slide .text .btn, hr");
          animation = "animated flipInX";

      $text.removeClass(animation).addClass(animation).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass(animation);
      });
      $headText.removeClass(animation).addClass(animation).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass(animation);
      });
      $button.removeClass(animation).addClass(animation).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass(animation);
      });
    }


    //-------------------------- 
    //Initializes slider of home page
    //-------------------------- 
    var initFlexslider = function() {
      //home page slider setup 
      $homepageSlideshow.removeClass('loading');
      $homepageSlideshow.find('.slider-loader').remove();
      $homepageSlideshow.flexslider({
        start: function(slider) {
          
          functionAnimateText(slider);
          
        },
        before: function(slider) {
          $(slider).find(".flex-active-slide .text, .flex-active-slide p, .flex-active-slide h1, .flex-active-slide .btn, hr").hide();
        },
        after: function(slider) {
          
          functionAnimateText(slider);
          
        },
        controlNav: true,               
        directionNav: true,             
        prevText: "",           
        nextText: "", 
      });
    }
    $('.slideshow').imagesLoaded()
      .done( function( instance ) {
        $homepageSlideshow.find('.slider-img').each(function() { 
          $(this).attr('src', $(this).data('src'));
        });
        $homepageSlideshow.find(".text, p, h1, .btn, hr").hide();
        initFlexslider();
      });
    

    //-------------------------- 
    //Used to swipe product image on hover of product thumb
    //-------------------------- 
    $productThumbandList.on('mouseenter', '.change-product-on-hover, .change-product-on-hover a', function() {
      var $this = $(this);
      var $img = $this.find('img');
      $img.attr("src", $this.data('hover-img'));  
    })
    $productThumbandList.on('mouseleave', '.change-product-on-hover, .change-product-on-hover a', function() {
      var $this = $(this);
      var $img = $this.find('img');
      $img.attr("src", $(this).data('default-img'));
    })


    //-------------------------- 
    //Used to download swipe image of product thumb
    //-------------------------- 
    $('.product-thumb .change-product-on-hover').each(function() {
      var a = new Image(); 
      a.src =  $(this).data('hover-img');
    });


    //-------------------------- 
    //Used to display website modal
    //-------------------------- 
    $window.load(function() {

      if($.cookie('popup-showed') != 1) {
        $('#newsletter-modal').modal('show');
      }

      
      $('#main-navigation').affix({
        offset: {
          top: ($('#top-nav').height() + $('.site-header').height())-$('#nav').height()
        }
      });
       

      // Website animation
    });
    $('#newsletter-modal').on('hidden.bs.modal', function () {
      $.cookie('popup-showed', 1);
    })
       

    //-------------------------- 
    //searchbox
    //-------------------------- 
    var $submitIcon = $('.searchbox-icon');
    var $inputBox = $('.searchbox-input');
    var $searchBox = $('.searchbox');
    var isOpen = false;
    $submitIcon.click(function(){
      if(isOpen == false){
        $searchBox.addClass('searchbox-open');
        $inputBox.focus();
        isOpen = true;
      } else {
        $searchBox.removeClass('searchbox-open');
        $inputBox.focusout();
        isOpen = false;
      }
    });  
    $submitIcon.mouseup(function(){
      return false;
    });
    $searchBox.mouseup(function(){
      return false;
    });
    $(document).mouseup(function(){
      if(isOpen == true){
        $('.searchbox-icon').css('display','block');
        $submitIcon.click();
      }
    });


    //-------------------------- 
    //Callback method of product variant change dropdown of quick view
    //-------------------------- 
    var selectCallbackQV = function(variant, selector) {

      if (variant) {

        if (variant.available) {
          // Selected a valid variant that is available.
          $('#add').removeClass('disabled').removeAttr('disabled').val('Add to Cart').fadeTo(200,1);
        } else {
          // Variant is sold out.
          $('#add').val('Sold Out').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);        
        }
        // Whether the variant is in stock or not, we can update the price and compare at price.
        if ( variant.compare_at_price > variant.price ) {
          $('#quick-view-modal').find('#price-preview-qv').html('<span class="product-price on-sale">'+ Shopify.formatMoney(variant.price, Venas.money_format) +'</span>'+'&nbsp;<del class="product-compare-price">'+Shopify.formatMoney(variant.compare_at_price, Venas.money_format)+ '</del>');
        } else {
          $('#quick-view-modal').find('#price-preview-qv').html('<span class="product-price">'+ Shopify.formatMoney(variant.price, Venas.money_format) + '</span>' );
        }       

        //
        

      } else {
        // variant doesn't exist.
        $('#add').val('Unavailable').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);
      }
    }  


    //-------------------------- 
    //Used to open product quick view modal
    //-------------------------- 
    $('body').on('click', '.quick-view-btn', function() {
      $('body').addClass('loading');
      var pthumb = $(this).closest('.product-thumb');

      Shopify.getProduct($(this).data('product-handle'), function(p) {
        
        $('#quick-view-modal').modal();
        
        var productJSON = p;
        p.show_vendor = true;

        var compiledHTML = $('#quickviewTemplate').tmpl(p);

        $('#quick-view-modal .modal-content').html(compiledHTML);
        

        $('body').removeClass('loading');
        
        new Shopify.OptionSelectors('product-select', {
          product: p,
          onVariantSelected: selectCallbackQV
        });
        
        for (var i = 0; i < p.options.length; i++) {
          $('body').find('#quick-view-modal label[for="product-select-option-'+i+'"]').text(p.options[i].name);
        };

        //
        Incrementers();
        $('#quick-view-modal').find('.ratting').html(pthumb.find('.spr-starrating').html());

        

        //animate main image on selection
        $('#quick-view-modal .thumb img').on('click', function() {
          $('#qv-main-img img').fadeOut(00);
          $('#qv-main-img img').attr('src', $(this).attr('src'));
          $('#qv-main-img img').fadeIn(300);
        });

        //product thumb slider init
        $(".owl-qv-thumbs").owlCarousel({ navigation: true, pagination: false, items: 4, navigationText: ["<i class='fa fa-angle-left btn btn-default btn-xs'></i>", "<i class='fa fa-angle-right btn btn-default btn-xs'></i>"] });

        if(productJSON.variants.length == 1 && productJSON.variants[0].title == 'Default Title') {
          $('body').find('#quick-view-modal .selector-wrapper').hide();
        }

      });
    })


    //-------------------------- 
    //Initializes infonite scroll on collection page
    //-------------------------- 
    


    //-------------------------- 
    //Initializes bootstrap tooltip
    //--------------------------
    $('[data-toggle="tooltip"]').tooltip()
    

    //-------------------------- 
    //Parallax background
    //--------------------------
    // $('.testimonials').stellar();


    //-------------------------- 
    //Initializes Product zoom in product details page 
    //--------------------------
    $('#productPhotoImg').elevateZoom({ 
      zoomType  : "inner", 
      cursor: "crosshair", 
      loadingIcon: "//www.juthour.com/cdn/shop/t/2/assets/loader.gif?v=118403094610238722951507865863",
      gallery: "product-image-gallery" 
    });
    
    $("#productPhotoImg").bind("click", function(e) { 
      var ez = $('#productPhotoImg').data('elevateZoom'); 
      $.fancybox(ez.getGalleryList()); 
      return false;  
    }); 
    


    //-------------------------- 
    //display view all button in front page collections if collection products is geater than 8
    //--------------------------
    $('#frontpage-collections-2 ul li a').each(function() {
      var $this = $(this);
      $this.click(function (e) {
          e.preventDefault();
          $this.tab('show');
      });
      var $this = $('#frontpage-collections-2 ul li:eq(0) a');
      if($this.data('total-products') <= 8) {
        $('#frontpage-collections-2 .fpc-viewall').hide();
      }
      else {
        $('#frontpage-collections-2 .fpc-viewall').attr('href', $this.data('url')).show();
      }
    }); 
    $('#frontpage-collections ul li a').each(function() {
      var $this = $(this);
      $this.click(function (e) {
          e.preventDefault();
          $this.tab('show');
      });
      var $this = $('#frontpage-collections ul li:eq(0) a');
      if($this.data('total-products') <= 8)
        $('#frontpage-collections .fpc-viewall').hide();
      else 
        $('#frontpage-collections .fpc-viewall').attr('href', $this.data('url')).show();
    }); 
    $('#frontpage-collections-2').on( 'shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
      if($(this).data('total-products') <= 8)
        $('#frontpage-collections-2 .fpc-viewall').hide();
      else 
        $('#frontpage-collections-2 .fpc-viewall').attr('href', $(this).data('url')).show();
    });
    $('#frontpage-collections').on( 'shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
      if($(this).data('total-products') <= 8)
        $('#frontpage-collections .fpc-viewall').hide();
      else 
        $('#frontpage-collections .fpc-viewall').attr('href', $(this).data('url')).show();
    });


    //-------------------------- 
    //owl slider init
    //--------------------------
    var owl = $(".owl-frontpage-collection");
    owl.owlCarousel({
      itemsCustom : [
        [0, 2],
        [450, 2],
        [600, 2],
        [700, 3],
        [1000, 5],
        [1200, 5],
        [1400, 5],
        [1600, 5]
      ],
      navigation : false,
      pagination: false,
      lazyLoad: true
    });
    var fp_collection_1 = function() {
      $('#frontpage-collections .fpc-next').on('click', function() {
        var active_owl = $("#frontpage-collections .tab-pane.active .owl-carousel").data('owlCarousel');
        if(!active_owl)
          active_owl = $("#frontpage-collections .owl-carousel").data('owlCarousel');
        if(active_owl)
          active_owl.next();
      });

      $('#frontpage-collections .fpc-prev').on('click', function() {
        var active_owl = $("#frontpage-collections .tab-pane.active .owl-carousel").data('owlCarousel');
        if(!active_owl)
          active_owl = $("#frontpage-collections .owl-carousel").data('owlCarousel');
        if(active_owl)
          active_owl.prev();
      });
    };
    var fp_collection_2 = function() {
      $('#frontpage-collections-2 .fpc-next').on('click', function() {
        var active_owl = $("#frontpage-collections-2 .tab-pane.active .owl-carousel").data('owlCarousel');
        if(!active_owl)
          active_owl = $("#frontpage-collections-2 .owl-carousel").data('owlCarousel');
        if(active_owl)
          active_owl.next();
        
      });

      $('#frontpage-collections-2 .fpc-prev').on('click', function() {
        var active_owl = $("#frontpage-collections-2 .tab-pane.active .owl-carousel").data('owlCarousel');
        if(!active_owl)
          active_owl = $("#frontpage-collections-2 .owl-carousel").data('owlCarousel');
        if(active_owl)
          active_owl.prev();
      });
    };
    var fp_collection_xs = function() {
      //Used for front page collection small 
      var owl_fp_xs_left = $(".cl-1 .owl-frontpage-collection-xs").owlCarousel({
        itemsCustom : [
          [0, 1],
          [450, 1],
          [600, 2],
          [700, 1],
          [1000, 2],
          [1200, 2],
          [1400, 2],
          [1600, 2]
        ],
        navigation : false,
        pagination: false
      }).data('owlCarousel');
      $('.cl-1 .fpc-next').on('click', function() {
        owl_fp_xs_left.next();
      });
      $('.cl-1 .fpc-prev').on('click', function() {
        owl_fp_xs_left.prev();
      });


      var owl_fp_xs_right = $(".cl-2 .owl-frontpage-collection-xs").owlCarousel({
        itemsCustom : [
          [0, 1],
          [450, 1],
          [600, 2],
          [700, 1],
          [1000, 2],
          [1200, 2],
          [1400, 2],
          [1600, 2]
        ],
        navigation : false,
        pagination: false
      }).data('owlCarousel');
      $('.cl-2 .fpc-next').on('click', function() {
        owl_fp_xs_right.next();
      });
      $('.cl-2 .fpc-prev').on('click', function() {
        owl_fp_xs_right.prev();
      });
    };
    var testimonials = function() {
      //Used to initialize testimonials plugin
      var owl_testimonials = $(".owl-testimonials").owlCarousel({
        singleItem: true,
        navigation : false,
        pagination: false,
        addClassActive: true
      }).data('owlCarousel');

      $('.testimonials .next').on('click', function() {
        console.log(this);
        owl_testimonials.next();
      });
      $('.testimonials .prev').on('click', function() {
        owl_testimonials.prev();
      });
    };
    var blogs = function() {
      //Used for front page blog
      var owl_blogs = $(".owl-fp-blog").owlCarousel({
        itemsCustom : [
          [0, 2],
          [450, 2],
          [600, 2],
          [700, 3],
          [1000, 4],
          [1200, 4],
          [1400, 4],
          [1600, 4]
        ],
        navigation : false,
        pagination: false
      }).data('owlCarousel');

      $('.front-page-blog .fpc-next').on('click', function() {
        owl_blogs.next();
      })

      $('.front-page-blog .fpc-prev').on('click', function() {
        owl_blogs.prev();
      })
    };
    var brands = function() {
      //Used for front page Brands
      var owl_brands = $(".owl-fp-brands").owlCarousel({
        itemsCustom : [
          [0, 2],
          [450, 2],
          [600, 3],
          [700, 4],
          [1000, 6],
          [1200, 6],
          [1400, 6],
          [1600, 6]
        ],
        navigation : false,
        pagination: false
      }).data('owlCarousel');;

      $('.brands .fpc-next').on('click', function() {
        owl_brands.next();
      })

      $('.brands .fpc-prev').on('click', function() {
        owl_brands.prev();
      })
    };
    var product_collection = function() {
      var owl_p_collection = $(".owl-product-collection").owlCarousel({
        itemsCustom : [
          [0, 2],
          [450, 2],
          [600, 2],
          [700, 3],
          [1000, 4],
          [1200, 4],
          [1400, 4],
          [1600, 4]
        ],
        navigation : false,
        pagination: false,
        lazyLoad: true
      }).data('owlCarousel');;

      $('.product-collection .fpc-next').on('click', function() {
        owl_p_collection.next();
      })

      $('.product-collection .fpc-prev').on('click', function() {
        owl_p_collection.prev();
      })
    };
    var related_product = function() {
      
      var owl_related_products = $(".owl-related-products").owlCarousel({
        itemsCustom : [
          [0, 1],
          [450, 1],
          [600, 1],
          [700, 1],
          [1000, 1],
          [1200, 1],
          [1400, 1],
          [1600, 1]
        ],
        navigation : false,
        pagination: false
      }).data('owlCarousel');;

      $('.related-products .fpc-next').on('click', function() {
        owl_related_products.next();
      });

      $('.related-products .fpc-prev').on('click', function() {
        owl_related_products.prev();
      });
    };
    var product_thumb = function() {
      var owl_p_thumb = $(".owl-pthumb-imgs").owlCarousel({
        itemsCustom : [
          [0, 2],
          [450, 2],
          [600, 2],
          [700, 3],
          [1000, 4],
          [1200, 4],
          [1400, 4],
          [1600, 4]
        ],
        navigation : false,
        pagination: false
      }).data('owlCarousel');;

      $('#product-image-gallery .next').on('click', function() {
        owl_p_thumb.next();
      });

      $('#product-image-gallery .prev').on('click', function() {
        owl_p_thumb.prev();
      });
    };
    fp_collection_1();
    fp_collection_2();
    fp_collection_xs();
    testimonials();
    blogs();
    brands();
    product_collection();
    related_product();
    product_thumb();
    Incrementers();


    //-------------------------- 
    //main navigation init
    //--------------------------
    $().jetmenu();
    $('.has-dropdown > a').click(function() { 
      window.location.href = $(this).attr('href');
    });    
    
  });
}(window.jQuery, window, document));

function buttonUp() {
  var inputVal = $('.searchbox-input').val();
  inputVal = $.trim(inputVal).length;
  if( inputVal !== 0){
      $('.searchbox-icon').css('display','none');
  } else {
      $('.searchbox-input').val('');
      $('.searchbox-icon').css('display','block');
  }  
}
